// extracted by mini-css-extract-plugin
module.exports = {"container":"single-line-input_container__CVyox","variant-textarea":"single-line-input_variant-textarea__valo9"};